const DECIMAL_OR_THOUSANDS_SEPARATOR = /(^\s*[1-9](\.|,)\d{3}\b)|(^\s*\d{2,3}(\.|,)\d{3}\b)/;

export default DECIMAL_OR_THOUSANDS_SEPARATOR;
